import script from "./CriticalScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./CriticalScreen.vue?vue&type=script&setup=true&lang=js"

import "./CriticalScreen.vue?vue&type=style&index=0&id=301b756f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-301b756f"]])

export default __exports__